import React, { useState, useRef } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,

} from 'reactstrap';
import moment from 'moment';
import { jsPDF } from "jspdf";
import { environment } from '../../env';
import Table from '../Table';
import blankUser from '../../images/blank-user.webp'
import { loaderAction, warningModalToggle } from '../../redux/actions/Index';
import EmptyTable from './../errorComponents/EmptyTable';
import "../BuildingViewCard/BuildingDropDown.css"
import 'jspdf-autotable'
import Excel from './../../Helper/Excel';
import SuccessPopups from '../Popups/SuccessPopups';
import WarningPopup from '../Popups/WarningPopup';
import { Trash } from '@phosphor-icons/react';
import AddPocModal from '../Modal/AddPocModal';
import DocumentsCard from '../DocumentsCard/DocumentsCard';
import EmptyDoc from '../errorComponents/EmptyDoc';
import PathName from '../PathName/PathName';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function InvestorViewCard() {
    const [investordata, setInvestorData] = useState()
    const [pocData, setPocData] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [docDeleteWarFront, setDocDeleteWarFront] = useState(false);
    const [investorproperties, setInvestorProperties] = useState([]);
    const [tenant, setTenant] = useState([])
    const [update, setUpdate] = useState(false)
    const [invtdocs, setInvtdocs] = useState([])
    const investorDetails = useRef(null)
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const navigate = useNavigate();
    const { id } = useParams()
    const dispatch = useDispatch();

    const user = useSelector((state) => state?.Reducers?.userdata);

    const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }

    const viewInvestorData = () => {
        axios.get(`${environment.baseUrl}editinvestor/${id}`).then(res => {
            setInvestorData(res.data)
            storeImg(res.data.image)

            // let arr = []
            // if (res.data?.aadhaar_doc != '') {
            //     arr.push({ documentname: "Aadhaar Card", documenturl: res.data.aadhaar_doc })
            // }
            // if (res.data?.pan_doc != '') {
            //     arr.push({ documentname: "Pan Card", documenturl: res.data.pan_doc })
            // }
            // setInvtdocs(arr);
        })
            .catch(res => {
                console.log("errorss");
            })

    }

    const getDocs = () => {
        axios.get(`${environment.baseUrl}investor-doc/${id}`).then(res => {
            let tempDocData = res.data.filter(item => item.view == 0)
            setInvtdocs(tempDocData)
        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const getPocList = () => {
        axios.get(`${environment.baseUrl}investor-poc/${id}`).then(res => {
            setPocData(res.data)
        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const getTenantList = () => {
        axios.get(`${environment.baseUrl}investor-tenant/${id}`).then(res => {
            const tenantList = res.data
            var filterData = [];
            tenantList.map((tenant, i) => {
                if (i == 0) {
                    for (let i = 0; i < tenant.piproposal.length; i++) {
                        if (tenant.piproposal[i]?.investor.Investors.id == id) {
                            tenant.piproposal = tenant.piproposal[i];
                            filterData.push(tenant)
                            break;
                        }
                    }
                } else {
                    for (let i = 0; i < tenant.piproposal.length; i++) {
                        if (filterData.find(o => o.piproposal?.investor?.sub_gala_name != tenant.piproposal[i].investor?.sub_gala_name)) {
                            tenant.piproposal = tenant.piproposal[i];
                            filterData.push(tenant)
                            break;
                        }
                    }
                }
            })
            setTenant(res.data)
        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const getInvestorProperties = () => {
        dispatch(loaderAction())
        axios
            .get(`${environment.baseUrl}investor-properties/${id}`)
            .then((res) => {
                setInvestorProperties(res.data);
            })
            .catch((res) => {
                dispatch(loaderAction())
                console.log("error");
            });
    };

    useEffect(() => {
        viewInvestorData();
        getDocs();
        getInvestorProperties()
        getPocList();
        getTenantList();
    }, [])
    useEffect(() => {
        if(update){
            getPocList();
        }
    }, [update])



    const storeImg = (image) => {
        getBase64FromUrl(image).then((data) => {
            setPrintImg(data)
        })
    }

    const columns = [
        {
            name: 'Name',
            selector: row => row.poc_name,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row.poc_contact_number ?? '-',
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Email',
            selector: row => row.poc_email,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Designation',
            selector: row => row.poc_desigation,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Comment',
            selector: row => row.poc_comment,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                {user?.role != 'superadmin' ?
                    <AddPocModal investor={row.id} data1={row} update={setUpdate} ttenant={false} type='edit' />
                    : <>
                        <AddPocModal investor={row.id} data1={row} update={setUpdate} ttenant={false} type='edit' />
                        <button onClick={() => deletePOCData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>
                    </>
                }
            </div>,
        },
    ];

    const column = [
        {
            name: 'Name',
            selector: row => row.poc_name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row.poc_contact_number ?? '-',
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Email',
            selector: row => row.poc_email,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Designation',
            selector: row => row.poc_desigation,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Comment',
            selector: row => row.poc_comment,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
    ];

    const columnns = [
        {
            name: 'Project Name',
            selector: row => row.project?.name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },

        {
            name: 'Building No',
            selector: row => row.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Gala No',
            selector: row => Number(row.gala?.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Sub Gala',
            selector: row => row.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area Owns',
            selector: row => (row.sold_gala_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent Area',
            selector: row => (row.rent_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Available Area',
            selector: row =>(row.sold_gala_area - row.resell_area) - row.rent_area + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ];

    const tenantcol = [
        {
            name: 'Tenant Name',
            selector: row => row.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building No',
            selector: row => row.building_no?.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Gala No.',
            selector: row => row.piproposal.investor?.gala?.gala_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Sub Gala',
            selector: row => row.piproposal.investor?.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => Math.floor(parseInt(row.piproposal.required_area)) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent Start',
            selector: row => moment(row?.gtproposal[0]?.rent_actual_start_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent End',
            selector: row => moment(row?.gtproposal[0]?.rent_actual_end_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },

    ];


    const deletePOCData = (id) => {
        dispatch(warningModalToggle(id));
    };

    const deletePoc = (id) => {
        dispatch(warningModalToggle(id))
        axios.delete(`${environment.baseUrl}investor-poc/${id}`).then(res => {
            if (res.data.code === 200) {
                getPocList();
                toast.success("POC Deleted Successfully.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
            }
        })
            .catch(res => {
                toast.error(res.response.data.detail, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
            })
    };

    const pdfDownload = () => {
        const content = investorDetails.current;
        var doc = new jsPDF()
        doc.text('Investor Details ', 15, 10)
        doc.html(content, {
            callback: (doc) => {

                if (investorproperties.length > 0) {
                    doc.setFontSize(15)
                    doc.text('Properties Details', 15, 58)
                    doc.autoTable({
                        html: '#investorProperty',
                        startY: 61,
                        theme: 'grid',
                        tableWidth: 'nowrap',
                        pageBreak: 'avoid',
                        styles: { cellPadding: 1, fontSize: 12 },
                        headStyles: { fillColor: [98, 113, 222] },
                        bodyStyles: { textColor: [0, 0, 0] }
                    })
                }
                if (pocData.length > 0) {
                    doc.setFontSize(15)
                    doc.text('POC Details', 15, doc.lastAutoTable.finalY + 10)
                    doc.autoTable({
                        html: '#pocTable',
                        startY: doc.lastAutoTable.finalY + 13,
                        theme: 'grid',
                        tableWidth: 'nowrap',
                        pageBreak: 'avoid',
                        styles: { cellPadding: 1, fontSize: 12 },
                        headStyles: { fillColor: [98, 113, 222] },
                        bodyStyles: { textColor: [0, 0, 0] }
                    })
                }

                if (tenant.length > 0) {
                    doc.setFontSize(15)
                    doc.text('Tenant Details', 15, doc.lastAutoTable.finalY + 10)
                    doc.autoTable({
                        html: '#tenantTable',
                        startY: doc.lastAutoTable.finalY + 13,
                        theme: 'grid',
                        tableWidth: 'nowrap',
                        pageBreak: 'avoid',
                        styles: { cellPadding: 1, fontSize: 12 },
                        headStyles: { fillColor: [98, 113, 222] },
                        bodyStyles: { textColor: [0, 0, 0] }
                    })
                }
                window.open(doc.output('bloburl'));
            },
            html2canvas: { scale: 0.18 },
            margin: [11, 2, 2, 2],
        })
    }

    const deleteDocument = (id) => {
        dispatch(warningModalToggle(id));
        setDocDeleteWarFront(true);
    }

    const deleteDoc = (id) => {
        dispatch(warningModalToggle(id))
        axios.put(`${environment.baseUrl}investor-doc/${id}`, { view: 1 }).then(res => {
            if (res.data.code === 200) {
                getDocs();
                toast.success("Document Deleted Successfully", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
            }
        })
            .catch(res => {
                console.log("error");
                toast.error("Something Went Wrong", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
            })
        setDocDeleteWarFront(false)
    }

    return (
        <>
            <PathName />
            <SuccessPopups />
            {!docDeleteWarFront && <WarningPopup deleteData={deletePoc} update={setUpdate} />}
            {docDeleteWarFront && <WarningPopup deleteData={deleteDoc} update={setUpdate} />}
            <div className="d-flex justify-content-between align-items-center py-5 px-3 pt-2">
                <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                    <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                    <span className='fs-3 base-font-600'>Back</span> </button>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle className="border-0 bg-transparent">
                        <div className="buttons px-3 py-3 rounded-3"  >
                            <i className='bx-tada bx bx-download fs-1 base-text-color ' ></i>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className='shadow-lg bg-body rounded-4 border-0 dropdown-menus p-3 '>
                        <DropdownItem onClick={pdfDownload} className='border-0 outline-none px-2 py-2 d-flex align-items-center'>
                            <i className="fa-regular fa-file-pdf fs-1 base-text-color px-2"></i>
                            <span className='text-dark text-decoration-none title-font-500 fs-3 dropdown-item px-4'>PDF</span>

                        </DropdownItem>
                        <DropdownItem className='border-0 outline-none  px-2 py-2 d-flex align-items-center'>
                            <Excel data={investorproperties} poc={pocData} investor={true} />
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className="card w-100 border-0 rounded-5 shadow p-3 p-sm-4 p-md-5 p-lg-5 p-xl-5 ">
                    <div ref={investorDetails} className="row align-items-center justify-content-center py-3">
                        <div className="col-3 user-card-img ">
                            {investordata?.image === "" || investordata?.image === undefined || investordata?.image === null ? <img src={blankUser} className="invastor-img-cards" alt="invasterImage" /> : <img id="invasterImage" src={`${investordata?.image}`} className="invastor-img-cards" alt="invasterImage" />}
                        </div>
                        <div className="col-9 row border-start ms-5 border-2 py-3">
                            <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                <h5 className="fs-3 title-font-800 text-base-black">Name :  <span className='fs-3 base-font-500 text-black'>{investordata?.name}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Email : <span className='fs-3 base-font-500 text-black'>{investordata?.email === "null" ? "--------" : investordata?.email}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Contact No : <span className='fs-3 base-font-500 text-black'>{investordata?.contact_number === "null" ? "--------" : investordata?.contact_number}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Address : <span className='fs-3 base-font-500 text-black text-capitalize'>{investordata?.address === "null" ? "--------" : investordata?.address}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Building No : <span className='fs-3 base-font-500 text-black'>{investordata?.building?.building_no === "null" ? "--------" : investordata?.building?.building_no}</span> </h5>
                            </div>
                            <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                <h5 className="fs-3 title-font-800 text-base-black">Aadhar No :  <span className='fs-3 base-font-500 text-black'>{investordata?.aadhar_no === "null" ? "--------" : investordata?.aadhar_no}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Pan No : <span className='fs-3 base-font-500 text-black text-uppercase'>{investordata?.pan_no === "null" ? "--------" : investordata?.pan_no}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">GST : <span className='fs-3 base-font-500 text-black text-uppercase'>{investordata?.gst === "null" ? "--------" : investordata?.gst}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Gala No : <span className='fs-3 base-font-500 text-black'>{investordata?.gala?.gala_no === "null" ? "--------" : investordata?.gala?.gala_no}</span> </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                <div className="bg-white p-5 d-flex gap-5 flex-column rounded-5 mb-5">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="title-font-bold ">Documents</h1>
                    </div>
                    <hr />
                    {invtdocs.length == 0 && (<div className="bg-white d-flex gap-5 flex-column justify-content-center align-items-center rounded-5 mb-5">
                            <h1 className="text-base-color title-font-700 text-capitalize">No Documents available...🤷🏻‍♂️</h1></div>)}
                    {invtdocs.length != 0 && <DocumentsCard documentDetails={invtdocs} investor={true} handle={deleteDocument} />}
                </div>
            }
            {
                pocData.length !== 0 && <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className='mb-5 title-font-bold '>POC</h1>
                    </div>
                    <Table columns={user?.role == "user" ? column : columns} data={pocData} />
                </div>
            }
            {investorproperties?.length !== 0 &&
                <>
                    <div className="bg-white p-5 rounded-5 mb-5 shadow-sm" >
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>Properties</h1>
                        </div>
                        {investorproperties?.length !== 0 ? <Table columns={columnns} data={investorproperties} inves={true} /> : <EmptyTable />}
                    </div>
                </>

            }

            {tenant?.length !== 0 &&
                <>
                    <div className="bg-white p-5 rounded-5 mb-5 shadow-sm" >
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>Tenants</h1>
                        </div>
                        {tenant?.length !== 0 ? <Table columns={tenantcol} data={tenant} inves={true} /> : <EmptyTable />}
                    </div>
                </>

            }
            <table id="investorProperty">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Project Name</th>
                        <th>Building No</th>
                        <th>Gala No</th>
                        <th>Area Own</th>
                        <th>Rent Area</th>
                        <th>Available Area</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        investorproperties?.length !== 0 && investorproperties?.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.project?.name}</td>
                                    <td>{row.building?.building_no}</td>
                                    <td>{row.gala?.gala_no}</td>
                                    <td>{row.sold_gala_area}</td>
                                    <td>{row.rent_area}</td>
                                    <td>{row.sold_gala_area - row.rent_area}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <table id="pocTable">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Contact No</th>
                        <th>Email</th>
                        <th>Designation</th>
                        <th>Comment</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        pocData?.length !== 0 && pocData?.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.poc_name}</td>
                                    <td>{row.poc_contact_number ?? '-'}</td>
                                    <td>{row.poc_email}</td>
                                    <td>{row.poc_desigation}</td>
                                    <td>{row.poc_comment}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

            <table id="tenantTable">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Tenant Name</th>
                        <th>Building No</th>
                        <th>Gala No</th>
                        <th>Sub Gala</th>
                        <th>Area</th>
                        <th>Rent Start</th>
                        <th>Rent End</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tenant?.length !== 0 && tenant?.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.name_of_company}</td>
                                    <td>{row.building_no?.building_no}</td>
                                    <td>{row.piproposal.investor?.gala?.gala_no}</td>
                                    <td>{row.piproposal.investor?.sub_gala_name}</td>
                                    <td>{parseInt(row.piproposal.required_area)}</td>
                                    <td>{moment(row?.gtproposal[0]?.rent_actual_start_date).format('DD/MM/YYYY')}</td>
                                    <td>{moment(row?.gtproposal[0]?.rent_actual_end_date).format('DD/MM/YYYY')}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>
    )
}




export default InvestorViewCard